<div class="border-top">
    <div class="container-md pt-2 pb-sm-2">
        <div class="row align-items-center justify-content-between">
            <div class="col-12 col-md-auto pb-1 pb-md-0 mr-auto">
                <ng-container *ngIf="contractAdminLink">
                    <a class="btn btn-sm btn-outline-primary btn-block" href="{{contractAdminLink}}">
                        {{contractAdminLinkText}}
                    </a>
                </ng-container>
            </div>
            <div class="col-12 col-sm-auto pr-sm-0 w-25">
                <label class="input-group m-0">
                    <div class="input-group-prepend">
                        <span class="input-group-text">
                            <div class="swapa-search"></div>
                        </span>
                    </div>
                    <input [(ngModel)]="searchText"
                           type="text"
                           class="form-control"
                           name="txtSearch"
                           #txtSearch
                           (ngModelChange)="onTextChange($event)"
                           placeholder="{{searchTextPlaceholder}}" />

                </label>
            </div>

            <div class="col-auto d-flex align-items-center pl-sm-2">
                <span class="pb-1 pl-sm-2 h3 m-0 font-weight-normal">
                    <button [disabled]="(!filterMetadata.count) ||(filterMetadata.count==1)" class="btn btn-link pr-2 p-0" (click)="findPrev()"><h3>&and;</h3></button>
                    <button [disabled]="(!filterMetadata.count)|| (filterMetadata.count==1)" class="btn btn-link pr-2 p-0" (click)="findNext()"><h3>&or;</h3></button>
                </span>
                <span class="pl-2 pl-sm-0 order-sm-first">
                    {{ index.count }}
                    of  {{ filterMetadata.count }} results
                </span>
            </div>
            <div class="col-auto ml-sm-auto">
                <button class="btn btn-link swapa-contract-toggle-all px-0" (click)="toggleAllSections($event)">
                    Collapse/Expand All
                </button>
            </div>
        </div>
    </div>
</div>
